<template>
  <v-app>
    <atlas-app-bar></atlas-app-bar>
    <v-main>
      <v-alert v-model="error" type="error" dark width="500px" dismissible>
        {{ errormsg }}
      </v-alert>
      <v-alert v-model="storeError" type="error" dark width="500px" dismissible>
        {{ storeErrorMsg }}
      </v-alert>
      <router-view v-if="!error && !storeError"></router-view>
    </v-main>
  </v-app>
</template>

<script>
import AtlasAppBar from '@/components/generic/AtlasAppBar.vue';

import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';

export default {
  name: 'App',
  components: {
    AtlasAppBar,
  },
  data() {
    return {
      error: false,
      errormsg: 'Unknown error, please contact Atlas Admin!',
      storeErrorProxy: null,
      storeErrorMsgProxy: 'Unknown server error, please contact Atlas Admin!',
    };
  },
  computed: {
    ...mapGetters(['getConnected', 'getErrored', 'getErrorMsg', 'getStatus']),
    storeError: {
      get: function() {
        return this.storeErrorProxy == null ? this.getErrored : this.storeErrorProxy;
      },
      set: function(val) {
        this.storeErrorProxy = val;
      },
    },
    storeErrorMsg: {
      get: function() {
        return this.storeErrorMsgProxy == null ? this.getErrorMsg : this.storeErrorMsgProxy;
      },
      set: function(val) {
        this.storeErrorMsgProxy = val;
      },
    },
  },
  watch: {
    storeErrorProxy(val) {
      if (val != null) {
        this.setErrored(val);
      }
    },
    storeErrorMsgProxy(val) {
      if (val != null) {
        this.setErrorMsg(val);
      }
    },
    getErrored() {
      this.storeErrorProxy = null;
    },
    getErrorMsg() {
      this.storeErrorMsgProxy = null;
    },
    getStatus(val) {
      if (val !== true) {
        this.error = true;
        this.errormsg =
          'System Maintenance... We apologize for the inconvenience, please try again later';
      }
    },
  },
  created() {
    this.fetchStatus();
  },
  errorCaptured(err) {
    this.error = true;
    console.log('Captured error in app : ', err.stack);
  },
  methods: {
    ...mapActions(['login', 'fetchStatus']),
    ...mapMutations(['setErrored', 'setErrorMsg']),
  },
};
</script>
<style scoped>
.v-alert {
  margin: 100px auto;
}
</style>
